import React from 'react';
import {
  Container, Typography, Box, Stack, Grid,
} from '@mui/material';
import {
  Card,
  ListItemCardContent,
  ListItemCardTitle,
  ListItemCardSubtitle,
  Link,
} from '@marageti/z4-lib';
import { HomeLink, ViewProps } from './types';

const LinkCard = ({
  href,
  title,
  subTitle,
  icon,
}:HomeLink) => (
  <Link
    to={href}
    sx={{
      maxWidth: {
        desktop: '434px',
      },
      width: {
        desktop: '100%',
      },
    }}
  >
    <Card
      sx={{
        '&:hover': {
          bgcolor: 'grey.A100',
        },
        height: '100%',
      }}
    >
      <ListItemCardContent>
        <Stack>
          <ListItemCardTitle>{title}</ListItemCardTitle>
          <ListItemCardSubtitle>{subTitle}</ListItemCardSubtitle>
        </Stack>
        {icon && (icon)}
      </ListItemCardContent>
    </Card>
  </Link>
);

const HomeView = ({
  links,
  date,
  givenName,
}: ViewProps) => (
  <Container
    sx={{
      maxWidth: {
        desktop: 'md',
      },
    }}
  >
    <Box
      sx={{
        py: { desktop: 5, mobile: 3 },
        minHeight: {
          desktop: 'calc(100vh - 298px)',
        },
      }}
    >
      <Typography variant="subtitle1">{date}</Typography>
      <Typography variant="h2" style={{ marginBottom: '24px' }}>
        Welcome,&nbsp;
        {givenName}
      </Typography>
      <Grid container spacing={2}>
        { links.map((ele) => (
          <Grid width={100} item sm={6} xs={12} key={ele.title}>
            <LinkCard
              key={ele.title}
              href={ele.href}
              title={ele.title}
              subTitle={ele.subTitle}
              icon={ele.icon}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  </Container>
);

export default HomeView;
